module.exports = __webpack_public_path__ + "cert_2.jpg?118da6a77abeda85649aae49748100a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cert_2.jpg
// module id = 32
// module chunks = 0